import * as $ from 'jquery';

export default (function () {
    window.moneyUtils = {
        BRL(value) {
            return currency(value, { symbol: 'R$ ', decimal: ',', separator: '.' });
        }
    }
}());